"use client";

import React, { useRef } from "react";
import { Button } from "../ui/button";

const ScrollButton = ({ variant, size, className, name, onClick }) => {
  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={onClick}
    >
      <p>{name}</p>
    </Button>
  );
};

export default ScrollButton;
